export default {
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                  Auth                        //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    AUTH_FLOW_LOGIN_REQUEST_SESSION:                'AUTH_FLOW_LOGIN_REQUEST_SESSION',
    AUTH_FLOW_LOGIN_REQUEST_FORCE_SESSION:          'AUTH_FLOW_LOGIN_REQUEST_FORCE_SESSION',
    AUTH_FLOW_LOGIN_REQUEST_BYPASS:                 'AUTH_FLOW_LOGIN_REQUEST_BYPASS',
    AUTH_FLOW_LOGIN_REQUEST_FORCE_BYPASS:           'AUTH_FLOW_LOGIN_REQUEST_FORCE_BYPASS',
    AUTH_FLOW_LOGOUT_REQUEST_CLIENT:                'AUTH_FLOW_LOGOUT_REQUEST_CLIENT',
    AUTH_FLOW_LOGOUT_REQUEST_WP:                    'AUTH_FLOW_LOGOUT_REQUEST_WP',
    AUTH_FLOW_SUCCESS:                              'AUTH_FLOW_SUCCESS',
    AUTH_FLOW_ERROR:                                'AUTH_FLOW_ERROR',


    AUTH_CHECK_REQUEST:                             'AUTH_CHECK_REQUEST',
    AUTH_CHECK_SUCCESS:                             'AUTH_CHECK_SUCCESS',
    AUTH_CHECK_ERROR:                               'AUTH_CHECK_ERROR',


    AUTH_CLEAR_DATA:                                'AUTH_CLEAR_DATA',

    AUTH_SET_SESSION_DATA:                          'AUTH_SET_SESSION_DATA',
    AUTH_SET_SESSION_DATA_ALIVE:                    'AUTH_SET_SESSION_DATA_ALIVE', 
    AUTH_SET_CAPS_DATA:                             'AUTH_SET_CAPS_DATA',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //              Clear data                      //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    CLEAR_ALL_DATA:                                 'CLEAR_ALL_DATA',


    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                Load data                     //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    INIT_LOAD_REQUEST:                              'INIT_LOAD_REQUEST',
    INIT_LOAD_SUCCESS:                              'INIT_LOAD_SUCCESS',
    INIT_LOAD_ERROR:                                'INIT_LOAD_ERROR',
    LOAD_ALL_DATA_REQUEST:                          'LOAD_ALL_DATA_REQUEST',
    LOAD_ALL_DATA_SUCCESS:                          'LOAD_ALL_DATA_SUCCESS',
    LOAD_ALL_DATA_ERROR:                            'LOAD_ALL_DATA_ERROR',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                     API                      //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    
    //#region API
    PROGRAM_FETCH_REQUEST:                              'PROGRAM_FETCH_REQUEST',
    PROGRAM_FETCH_SUCCESS:                              'PROGRAM_FETCH_SUCCESS',
    PROGRAM_FETCH_ERROR:                                'PROGRAM_FETCH_ERROR',

    PROGRAM_GET_REQUEST:                                'PROGRAM_GET_REQUEST',
    PROGRAM_GET_SUCCESS:                                'PROGRAM_GET_SUCCESS',
    PROGRAM_GET_ERROR:                                  'PROGRAM_GET_ERROR',

    PROGRAM_UPDATE_REQUEST:                             'PROGRAM_UPDATE_REQUEST',
    PROGRAM_UPDATE_SUCCESS:                             'PROGRAM_UPDATE_SUCCESS',
    PROGRAM_UPDATE_ERROR:                               'PROGRAM_UPDATE_ERROR',

    PROGRAM_FILTER_REQUEST:                             'PROGRAM_FILTER_REQUEST',
    PROGRAM_FILTER_SUCCESS:                             'PROGRAM_FILTER_SUCCESS',
    PROGRAM_FILTER_ERROR:                               'PROGRAM_FILTER_ERROR',

    PROGRAM_CREATE_ITEM_REQUEST:                        'PROGRAM_CREATE_ITEM_REQUEST',
    PROGRAM_CREATE_ITEM_SUCCESS:                        'PROGRAM_CREATE_ITEM_SUCCESS',
    PROGRAM_CREATE_ITEM_ERROR:                          'PROGRAM_CREATE_ITEM_ERROR',


    //#endregion


    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                   programData                //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region programData

    PROGRAM_UPDATE_ITEM_UPDATE:                              'PROGRAM_UPDATE_ITEM_UPDATE',
    PROGRAM_UPDATE_ITEM_DELETE:                              'PROGRAM_UPDATE_ITEM_DELETE',
    PROGRAM_UPDATE_ITEM_LOCAL_UPDATE:                        'PROGRAM_UPDATE_ITEM_LOCAL_UPDATE',
    PROGRAM_UPDATE_ITEM_LOCAL_DELETE:                        'PROGRAM_UPDATE_ITEM_LOCAL_DELETE',
    PROGRAM_UPDATE_RESET:                                    'PROGRAM_UPDATE_RESET',

    MOVIES_UPDATE_ITEM_REQUEST:                              'MOVIES_UPDATE_ITEM_REQUEST',
    MOVIES_UPDATE_ORDER_REQUEST:                             'MOVIES_UPDATE_ORDER_REQUEST',
    
    MOVIE_EXTENSIONS_UPDATE_ITEM:                            'MOVIE_EXTENSIONS_UPDATE_ITEM',
    MOVIE_EXTENSIONS_ADD_ITEM_TO_RESET:                      'MOVIE_EXTENSIONS_ADD_ITEM_TO_RESET',

    CLIMOVIES_UPDATE_ITEM:                                   'CLIMOVIES_UPDATE_ITEM',
    CLIMOVIES_UPDATE_ORDER:                                  'CLIMOVIES_UPDATE_ORDER',

    PMMOVIES_UPDATE_ITEM_EDITABLE_ATTRIBUTES:                'PMMOVIES_UPDATE_ITEM_EDITABLE_ATTRIBUTES',
    PMMOVIES_UPDATE_ITEM_ORDER:                              'PMMOVIES_UPDATE_ITEM_ORDER',
    METAMOVIES_UPDATE_ITEM_ORIGIN:                           'METAMOVIES_UPDATE_ITEM_ORIGIN',


    ITEMSELECTIONSDISPLAY_REQUEST_ADD_ITEM:                 'ITEMSELECTIONSDISPLAY_REQUEST_ADD_ITEM',
    ITEMSELECTIONSDISPLAY_REQUEST_DELETE_ITEM:              'ITEMSELECTIONSDISPLAY_REQUEST_DELETE_ITEM',
    ITEMSELECTIONSDISPLAY_REQUEST_UPDATE_ORDER:             'ITEMSELECTIONSDISPLAY_REQUEST_UPDATE_ORDER',
    ITEMSELECTIONSDISPLAY_UPDATE_ITEM:                      'ITEMSELECTIONSDISPLAY_UPDATE_ITEM',
    ITEMSELECTIONSDISPLAY_DELETE_ITEM:                      'ITEMSELECTIONSDISPLAY_DELETE_ITEM',
    ITEMSELECTIONSDISPLAY_UPDATE_ORDER:                     'ITEMSELECTIONSDISPLAY_UPDATE_ORDER',
    ITEMSELECTIONSDISPLAY_UPDATE_ITEM_ORDER:                'ITEMSELECTIONSDISPLAY_UPDATE_ITEM_ORDER',
    
    ITEMSELECTIONS_ADD_ITEM:                                'ITEMSELECTIONS_ADD_ITEM',
    // ITEMSELECTIONS_UPDATE_ITEM:                             'ITEMSELECTIONS_UPDATE_ITEM',
    ITEMSELECTIONS_DELETE_ITEM:                             'ITEMSELECTIONS_DELETE_ITEM',
    ITEMSELECTIONS_UPDATE_ITEM_SETTINGS:                    'ITEMSELECTIONS_UPDATE_ITEM_SETTINGS',
    ITEMSELECTIONS_UPDATE_ITEM_SHOWINAPP:                   'ITEMSELECTIONS_UPDATE_ITEM_SHOWINAPP',
    // ITEMSELECTIONS_UPDATE_ITEM_COLLECTIONS:                 'ITEMSELECTIONS_UPDATE_ITEM_COLLECTIONS',

    // ITEMCOLLECTIONS_ADD_ITEM:                               'ITEMCOLLECTIONS_ADD_ITEM',
    ITEMCOLLECTIONS_DELETE_ITEM:                            'ITEMCOLLECTIONS_DELETE_ITEM',
    ITEMCOLLECTIONS_UPDATE_ITEM_ITEMS:                      'ITEMCOLLECTIONS_UPDATE_ITEM_ITEMS',
    ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_TRUE:                'ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_TRUE',
    ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_FALSE:               'ITEMCOLLECTIONS_UPDATE_ITEM_EDITED_FALSE',


    PROGRAM_ITEM_REORDER_REQUEST:                           'PROGRAM_ITEM_REORDER_REQUEST',


    ATTRIBUTES_UPDATE:                                      'ATTRIBUTES_UPDATE',


    ADS_REQUEST_ADD_ITEM:                                   'ADS_REQUEST_ADD_ITEM',
    ADS_ADD_ITEM:                                           'ADS_ADD_ITEM',
    ADS_UPDATE_ITEM:                                        'ADS_UPDATE_ITEM',
    ADS_DELETE_ITEM:                                        'ADS_DELETE_ITEM',

    
    ADVERTISEMENTS_REQUEST_ADD_ITEM:                        'ADVERTISEMENTS_REQUEST_ADD_ITEM',
    ADVERTSIEMENTS_REQUEST_DELETE_ITEM:                     'ADVERTSIEMENTS_REQUEST_DELETE_ITEM',
    // ADVERTSIEMENTS_REQUEST_UPDATE_ORDER:                    'ADVERTSIEMENTS_REQUEST_UPDATE_ORDER',
    ADVERTISEMENTS_ADD_ITEM:                                'ADVERTISEMENTS_ADD_ITEM',
    ADVERTISEMENTS_UPDATE_ITEM:                             'ADVERTISEMENTS_UPDATE_ITEM',
    ADVERTISEMENTS_DELETE_ITEM:                             'ADVERTISEMENTS_DELETE_ITEM',
    ADVERTISEMENTS_UPDATE_ORDER:                            'ADVERTISEMENTS_UPDATE_ORDER',
    ADVERTISEMENTS_UPDATE_ITEM_ORDER:                       'ADVERTISEMENTS_UPDATE_ITEM_ORDER',


    HIGHLIGHTS_REQUEST_ADD_ITEM:                            'HIGHLIGHTS_REQUEST_ADD_ITEM',
    HIGHLIGHTS_ADD_ITEM:                                    'HIGHLIGHTS_ADD_ITEM',
    HIGHLIGHTS_UPDATE_ITEM:                                 'HIGHLIGHTS_UPDATE_ITEM',
    HIGHLIGHTS_DELETE_ITEM:                                 'HIGHLIGHTS_DELETE_ITEM',

    WEISCHERAD_REQUEST_ADD_ITEM:                            'WEISCHERAD_REQUEST_ADD_ITEM',
    WEISCHERAD_ADD_ITEM:                                    'WEISCHERAD_ADD_ITEM',
    WEISCHERAD_UPDATE_ITEM:                                 'WEISCHERAD_UPDATE_ITEM',
    WEISCHERAD_DELETE_ITEM:                                 'WEISCHERAD_DELETE_ITEM',

    BRAND_MOVIE_MAPPINGS_CREATE_ITEM:                       'BRAND_MOVIE_MAPPINGS_CREATE_ITEM',
    BRAND_MOVIE_MAPPINGS_DELETE_ITEM:                       'BRAND_MOVIE_MAPPINGS_DELETE_ITEM',

    BRAND_MOVIE_MAPPINGS_UPDATE_REQUEST:                    'BRAND_MOVIE_MAPPINGS_UPDATE_REQUEST',
    BRAND_MOVIE_MAPPINGS_UPDATE_SUCCESS:                    'BRAND_MOVIE_MAPPINGS_UPDATE_SUCCESS',
    BRAND_MOVIE_MAPPINGS_UPDATE_ERROR:                      'BRAND_MOVIE_MAPPINGS_UPDATE_ERROR',

    HAS_UPDATES_SET_TRUE:                                   'HAS_UPDATES_SET_TRUE',
    HAS_UPDATES_SET_FALSE:                                  'HAS_UPDATES_SET_FALSE',

    //#endregion programData

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 WP-Server-Data               //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region wpServerData
    WP_PAGES_GET_REQUEST:                           'WP_PAGES_GET_REQUEST',
    WP_PAGES_GET_SUCCESS:                           'WP_PAGES_GET_SUCCESS',
    WP_PAGES_GET_ERROR:                             'WP_PAGES_GET_ERROR',

    WP_SERVICEPAGES_GET_REQUEST:                    'WP_SERVICEPAGES_GET_REQUEST',
    WP_SERVICEPAGES_GET_SUCCESS:                    'WP_SERVICEPAGES_GET_SUCCESS',
    WP_SERVICEPAGES_GET_ERROR:                      'WP_SERVICEPAGES_GET_ERROR',

    WP_MENUITEMS_GET_REQUEST:                       'WP_MENUITEMS_GET_REQUEST',
    WP_MENUITEMS_GET_SUCCESS:                       'WP_MENUITEMS_GET_SUCCESS',
    WP_MENUITEMS_GET_ERROR:                         'WP_MENUITEMS_GET_ERROR',

    WP_DATA_GET_REQUEST:                            'WP_DATA_GET_REQUEST',
    WP_DATA_GET_SUCCESS:                            'WP_DATA_GET_SUCCESS',
    WP_DATA_GET_ERROR:                              'WP_DATA_GET_ERROR',


    WP_DATA_UPDATE_REQUEST:                         'WP_DATA_UPDATE_REQUEST',
    WP_DATA_UPDATE_SUCCESS:                         'WP_DATA_UPDATE_SUCCESS',
    WP_DATA_UPDATE_ERROR:                           'WP_DATA_UPDATE_ERROR',

    //#endregion wpServerData
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 WP-Local-Data                //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region wpLocalData
    WP_LOCAL_DATA_FRONT_UPDATE_BY_KEY:                  'WP_LOCAL_DATA_FRONT_UPDATE_BY_KEY',
    
    //#endregion wpLocalData


  
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 WP-Routs-Data                //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    WP_ROUTES_DATA_GET_REQUEST:                         'WP_ROUTES_DATA_GET_REQUEST',
    WP_ROUTES_DATA_GET_SUCCESS:                         'WP_ROUTES_DATA_GET_SUCCESS',
    WP_ROUTES_DATA_GET_ERROR:                           'WP_ROUTES_DATA_GET_ERROR',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 Cli-Data                //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    CLI_DATA_GET_REQUEST:                               'CLI_DATA_GET_REQUEST',
    CLI_DATA_GET_SUCCESS:                               'CLI_DATA_GET_SUCCESS',
    CLI_DATA_GET_ERROR:                                 'CLI_DATA_GET_ERROR',
    
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               Print-Server-Data              //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region printServerData
    
    PRINT_DATA_GET_REQUEST:                            'PRINT_DATA_GET_REQUEST',
    PRINT_DATA_GET_SUCCESS:                            'PRINT_DATA_GET_SUCCESS',
    PRINT_DATA_GET_ERROR:                              'PRINT_DATA_GET_ERROR',
    
    
    PRINT_DATA_UPDATE_REQUEST:                         'PRINT_DATA_UPDATE_REQUEST',
    PRINT_DATA_UPDATE_SUCCESS:                         'PRINT_DATA_UPDATE_SUCCESS',
    PRINT_DATA_UPDATE_ERROR:                           'PRINT_DATA_UPDATE_ERROR',


    PRINT_DATA_FILTER_REQUEST:                          'PRINT_DATA_FILTER_REQUEST',
    PRINT_DATA_FILTER_SUCCESS:                          'PRINT_DATA_FILTER_SUCCESS',
    PRINT_DATA_FILTER_ERROR:                            'PRINT_DATA_FILTER_ERROR',


    // PRINT_DATA_FLYER_UPDATE_REQUEST:                    'PRINT_DATA_FLYER_UPDATE_REQUEST',
    // PRINT_DATA_FLYER_UPDATE_SUCCESS:                    'PRINT_DATA_FLYER_UPDATE_SUCCESS',
    // PRINT_DATA_FLYER_UPDATE_ERROR:                      'PRINT_DATA_FLYER_UPDATE_ERROR',
    // PRINT_DATA_FLYER_UPDATE_RESET:                      'PRINT_DATA_FLYER_UPDATE_RESET',

    PRINT_DATA_WEEKPROGRAMFLYER_PDF_REQUEST:            'PRINT_DATA_WEEKPROGRAMFLYER_PDF_REQUEST',
    PRINT_DATA_WEEKPROGRAMFLYER_PDF_SUCCESS:            'PRINT_DATA_WEEKPROGRAMFLYER_PDF_SUCCESS',
    PRINT_DATA_WEEKPROGRAMFLYER_PDF_ERROR:              'PRINT_DATA_WEEKPROGRAMFLYER_PDF_ERROR',
    PRINT_DATA_WEEKPROGRAMFLYER_PDF_RESET:              'PRINT_DATA_WEEKPROGRAMFLYER_PDF_RESET',

    PRINT_DATA_FLYER_PDF_REQUEST:                       'PRINT_DATA_FLYER_PDF_REQUEST',
    PRINT_DATA_FLYER_PDF_SUCCESS:                       'PRINT_DATA_FLYER_PDF_SUCCESS',
    PRINT_DATA_FLYER_PDF_ERROR:                         'PRINT_DATA_FLYER_PDF_ERROR',
    PRINT_DATA_FLYER_PDF_RESET:                         'PRINT_DATA_FLYER_PDF_RESET',

    PRINT_DATA_PRINT_TYPES_PDF_REQUEST:                 'PRINT_DATA_PRINT_TYPES_PDF_REQUEST',
    PRINT_DATA_PRINT_TYPES_PDF_SUCCESS:                 'PRINT_DATA_PRINT_TYPES_PDF_SUCCESS',
    PRINT_DATA_PRINT_TYPES_PDF_ERROR:                   'PRINT_DATA_PRINT_TYPES_PDF_ERROR',
    PRINT_DATA_PRINT_TYPES_PDF_RESET_STATE:             'PRINT_DATA_PRINT_TYPES_PDF_RESET_STATE',
    
    
    //#endregion printServerData
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               Print-Local-Data               //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region printLocalData
    PRINT_DATA_UPDATE_CURRENT_WEEK:                     'PRINT_DATA_UPDATE_CURRENT_WEEK',
    PRINT_LOCAL_DATA_UPDATE_BY_KEY:                     'PRINT_LOCAL_DATA_UPDATE_BY_KEY',
    
    PRINT_LOCAL_DATA_FRONT_UPDATE_BY_KEY:              'PRINT_LOCAL_DATA_FRONT_UPDATE_BY_KEY',

    PRINT_LOCAL_DATA_FLYER_UPDATE_CURRENT_WEEK:         'PRINT_LOCAL_DATA_FLYER_UPDATE_CURRENT_WEEK',
    PRINT_LOCAL_DATA_FLYER_ADD_FLYER_STRUCTURE_ITEM:    'PRINT_LOCAL_DATA_FLYER_ADD_FLYER_STRUCTURE_ITEM',
    PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_STRUCTURE_ITEM: 'PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_STRUCTURE_ITEM',
    PRINT_LOCAL_DATA_FLYER_ADD_FLYER_ELEMENT:           'PRINT_LOCAL_DATA_FLYER_ADD_FLYER_ELEMENT',
    PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_SETTINGS:       'PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_SETTINGS',
    PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ELEMENT:        'PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ELEMENT',
    PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ORDER:          'PRINT_LOCAL_DATA_FLYER_UPDATE_FLYER_ORDER',
    PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_ELEMENT:        'PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_ELEMENT',
    PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_CUSTOM_ELEMENT: 'PRINT_LOCAL_DATA_FLYER_DELETE_FLYER_CUSTOM_ELEMENT',
    PRINT_DATA_FLYER_UPDATE_TOO_HIGH:                   'PRINT_DATA_FLYER_UPDATE_TOO_HIGH',
    
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_CURRENT_WEEK:                'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_CURRENT_WEEK',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_DATE_SETTINGS:                  'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_DATE_SETTINGS',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_DATE_SETTINGS:               'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_DATE_SETTINGS',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_DATE_SETTINGS:               'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_DATE_SETTINGS',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_ALL_DATE_SETTINGS:               'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_ALL_DATE_SETTINGS',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_SETTINGS:   'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_SETTINGS',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_SET_CUSTOM_PERIOD_ACTIVE:           'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_SET_CUSTOM_PERIOD_ACTIVE',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_ORDER:      'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_ORDER',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_WEEKPROGRAMFLYER_ELEMENT:       'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_WEEKPROGRAMFLYER_ELEMENT',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_BULK_ADD_WEEKPROGRAMFLYER_ELEMENT:  'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_BULK_ADD_WEEKPROGRAMFLYER_ELEMENT',
    PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_WEEKPROGRAMFLYER_ELEMENT:    'PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_WEEKPROGRAMFLYER_ELEMENT',
    PRINT_DATA_WEEKPROGRAMFLYER_UPDATE_TOO_HIGH:                          'PRINT_DATA_WEEKPROGRAMFLYER_UPDATE_TOO_HIGH',
    
    
    //#endregion printLocalData
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               Push-Server-Data              //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~// 
    //#region pushData
    PUSH_DATA_GET_REQUEST:                          'PUSH_DATA_GET_REQUEST',
    PUSH_DATA_GET_SUCCESS:                          'PUSH_DATA_GET_SUCCESS',
    PUSH_DATA_GET_ERROR:                            'PUSH_DATA_GET_ERROR',       
    PUSH_DATA_CREATE_SUCCESS:                       'PUSH_DATA_CREATE_SUCCESS',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 PUSH-Create                   //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    
    PUSH_CREATE_REQUEST:                            'PUSH_CREATE_REQUEST',
    PUSH_CREATE_REQUEST_SUCCESS:                    'PUSH_CREATE_REQUEST_SUCCESS',
    PUSH_CREATE_REQUEST_ERROR:                      'PUSH_CREATE_REQUEST_ERROR',    
    PUSH_CREATE_ATTACHED_ITEM_UPDATE:               'PUSH_CREATE_ATTACHED_ITEM_UPDATE',
    PUSH_CREATE_FORM_UPDATE:                        'PUSH_CREATE_FORM_UPDATE',

    
    //#endregion pushLocalData
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 UI-Data                      //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region uiData

    PROGRAM_SET_EDIT_SLIDER_NAME:                   'PROGRAM_SET_EDIT_SLIDER_NAME',
    SETTINGS_SET_ACTIVE_SELECTION:                  'SETTINGS_SET_ACTIVE_SELECTION',
    SETTINGS_SET_ACTIVE_MENUITEM:                   'SETTINGS_SET_ACTIVE_MENUITEM',
    PROGRAM_SET_ACTIVE_TAB:                         'PROGRAM_SET_ACTIVE_TAB',
    PROGRAM_SET_ACTIVE_SELECTION:                   'PROGRAM_SET_ACTIVE_SELECTION',
    UI_PROGRAM_ACTIVE_DROPZONES_SET_TRUE:           'UI_PROGRAM_ACTIVE_DROPZONES_SET_TRUE',
    UI_PROGRAM_ACTIVE_DROPZONES_SET_FALSE:          'UI_PROGRAM_ACTIVE_DROPZONES_SET_FALSE',
    DASHBOARD_SET_ACTIVE_UPDATETEXT:                'DASHBOARD_SET_ACTIVE_UPDATETEXT',
    DASHBOARD_SET_DISPLAY_UPDATEHISTORY:            'DASHBOARD_SET_DISPLAY_UPDATEHISTORY',

    UI_PROGRAM_SET_EDIT_SELECTION:                  'UI_PROGRAM_SET_EDIT_SELECTION',

    UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE:    'UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE',
    // UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_DISPLAY: 'UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_DISPLAY',
    UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE:    'UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE',
    UI_GENERAL_REQUEST_OVERLAY_RESET:               'UI_GENERAL_REQUEST_OVERLAY_RESET',


    OVERLAY_SET_TYPE:                               'OVERLAY_SET_TYPE',
    OVERLAY_SET_RESET:                              'OVERLAY_SET_RESET',
    
    PRINT_SET_ACTIVE_TAB:                           'PRINT_SET_ACTIVE_TAB',
    

    //#endregion uiData

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 Print                        //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

    POST_POSTER_PDF_COMBINED_REQUEST:               'POST_POSTER_PDF_COMBINED_REQUEST',
    POST_POSTER_PDF_COMBINED_SUCCESS:               'POST_POSTER_PDF_COMBINED_SUCCESS',
    POST_POSTER_PDF_COMBINED_RESET_STATE:           'POST_POSTER_PDF_COMBINED_RESET_STATE',
    POST_POSTER_PDF_COMBINED_ERROR:                 'POST_POSTER_PDF_COMBINED_ERROR',
    PRINT_TOOL_ADD_ITEM:                            'PRINT_TOOL_ADD_ITEM',
    PRINT_TOOL_REORDER_ITEM:                        'PRINT_TOOL_REORDER_ITEM',
    PRINT_TOOL_DELETE_ITEM:                         'PRINT_TOOL_DELETE_ITEM',
    PRINT_TOOL_SET_WEEK:                            'PRINT_TOOL_SET_WEEK',
    PRINT_TOOL_CHOOSE_CINEMA:                       'PRINT_TOOL_CHOOSE_CINEMA',
    CHOOSE_AND_DELETE_ITEMS:                        'CHOOSE_AND_DELETE_ITEMS',

    SET_FLYER_STRUCTURE_ITEMS:                      'SET_FLYER_STRUCTURE_ITEMS',
    SET_FLYER_ELEMENTS:                             'SET_FLYER_ELEMENTS',


    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 Newsletter                   //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region newsletterData

    NEWSLETTER_GET_CAMPAIGNS_REQUEST:                         'NEWSLETTER_GET_CAMPAIGNS_REQUEST',
    NEWSLETTER_GET_CAMPAIGNS_SUCCESS:                         'NEWSLETTER_GET_CAMPAIGNS_SUCCESS',
    NEWSLETTER_GET_CAMPAIGNS_ERROR:                           'NEWSLETTER_GET_CAMPAIGNS_ERROR',

    NEWSLETTER_UPDATE_CAMPAIGN_REQUEST:                       'NEWSLETTER_UPDATE_CAMPAIGN_REQUEST',
    NEWSLETTER_UPDATE_CAMPAIGN_SUCCESS:                       'NEWSLETTER_UPDATE_CAMPAIGN_SUCCESS',
    NEWSLETTER_UPDATE_CAMPAIGN_ERROR:                         'NEWSLETTER_UPDATE_CAMPAIGN_ERROR',
    

    NEWSLETTER_GET_REQUEST:                                   'NEWSLETTER_GET_REQUEST',
    NEWSLETTER_GET_SUCCESS:                                   'NEWSLETTER_GET_SUCCESS',
    NEWSLETTER_GET_ERROR:                                     'NEWSLETTER_GET_ERROR',

    NEWSLETTER_UPDATE_REQUEST:                                'NEWSLETTER_UPDATE_REQUEST',
    NEWSLETTER_UPDATE_SUCCESS:                                'NEWSLETTER_UPDATE_SUCCESS',
    NEWSLETTER_UPDATE_ERROR:                                  'NEWSLETTER_UPDATE_ERROR',

    NEWSLETTER_FILTER_REQUEST:                                'NEWSLETTER_FILTER_REQUEST',
    NEWSLETTER_FILTER_SUCCESS:                                'NEWSLETTER_FILTER_SUCCESS',
    NEWSLETTER_FILTER_ERROR:                                  'NEWSLETTER_FILTER_ERROR',

    NEWSLETTER_SEND_REQUEST:                                  'NEWSLETTER_SEND_REQUEST',
    NEWSLETTER_SEND_SUCCESS:                                  'NEWSLETTER_SEND_SUCCESS',
    NEWSLETTER_SEND_ERROR:                                    'NEWSLETTER_SEND_ERROR',

    NEWSLETTER_CANCEL_REQUEST:                                 'NEWSLETTER_CANCEL_REQUEST',


    
    NEWSLETTER_CREATE_ITEM:                                   'NEWSLETTER_CREATE_ITEM',
    NEWSLETTER_UPDATE_ITEM:                                   'NEWSLETTER_UPDATE_ITEM',
    NEWSLETTER_DELETE_ITEM:                                   'NEWSLETTER_DELETE_ITEM',

    NEWSLETTER_UPDATE_NEWSLETTER_CURRENT_WEEK:                'NEWSLETTER_UPDATE_NEWSLETTER_CURRENT_WEEK',

    NEWSLETTER_ADD_NEWSLETTER_ITEM:                           'NEWSLETTER_ADD_NEWSLETTER_ITEM',
    NEWSLETTER_DELETE_NEWSLETTER_ITEM:                        'NEWSLETTER_DELETE_NEWSLETTER_ITEM',
    NEWSLETTER_REORDER_NEWSLETTER_ITEM:                       'NEWSLETTER_REORDER_NEWSLETTER_ITEM',
    //#endregion newsletterData


    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                 Signage                   //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region signageData

    // SIGNAGE_GET_REQUEST:                         'SIGNAGE_GET_REQUEST',
    // SIGNAGE_GET_SUCCESS:                         'SIGNAGE_GET_SUCCESS',
    // SIGNAGE_GET_ERROR:                           'SIGNAGE_GET_ERROR',
    // SIGNAGE_FILTER:                              'SIGNAGE_FILTER',


    // SIGNAGE_UPDATE_MOVIE_ITEM_DATES:            'SIGNAGE_UPDATE_MOVIE_ITEM_DATES',
    // SIGNAGE_RESET_DAY_COLLECTION_MOVIES:        'SIGNAGE_RESET_DAY_COLLECTION_MOVIES',
    // SIGNAGE_RESET_DAY_COLLECTION:               'SIGNAGE_RESET_DAY_COLLECTION',


    // SIGNAGE_ADD_CRAPP_ITEM_TO_DAY_COLLECTION:   'SIGNAGE_ADD_CRAPP_ITEM_TO_DAY_COLLECTION',

    // SIGNAGE_CRAP_ITEM_ADD:                      'SIGNAGE_CRAP_ITEM_ADD',

    //// new
    SIGNAGE_SCREEN_CREATE_REQUEST:              'SIGNAGE_SCREEN_CREATE_REQUEST',
    SIGNAGE_SCREEN_CREATE_SUCCESS:              'SIGNAGE_SCREEN_CREATE_SUCCESS',
    SIGNAGE_SCREEN_CREATE_ERROR:                'SIGNAGE_SCREEN_CREATE_ERROR',

    SIGNAGE_SCREEN_UPDATE_REQUEST:              'SIGNAGE_SCREEN_UPDATE_REQUEST',
    SIGNAGE_SCREEN_UPDATE_SUCCESS:              'SIGNAGE_SCREEN_UPDATE_SUCCESS',
    SIGNAGE_SCREEN_UPDATE_ERROR:                'SIGNAGE_SCREEN_UPDATE_ERROR',

    SIGNAGE_SCREEN_CREATE:                      'SIGNAGE_SCREEN_CREATE',
    SIGNAGE_SCREEN_UPDATE:                      'SIGNAGE_SCREEN_UPDATE',
    SIGNAGE_COLLECTION_CREATE:                  'SIGNAGE_COLLECTION_CREATE',
    SIGNAGE_COLLECTION_UPDATE:                  'SIGNAGE_COLLECTION_UPDATE',
    SIGNAGE_COLLECTION_DELETE:                  'SIGNAGE_COLLECTION_DELETE',


    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               MultisiteSelector              //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //#region multisiteSelectorData
    MULTISITE_SELECTOR_GET_REQUEST:             'MULTISITE_SELECTOR_GET_REQUEST',
    MULTISITE_SELECTOR_GET_SUCCESS:             'MULTISITE_SELECTOR_GET_SUCCESS',
    MULTISITE_SELECTOR_GET_ERROR:               'MULTISITE_SELECTOR_GET_ERROR',
    MULTISITE_SELECTOR_UPDATE_REQUEST:          'MULTISITE_SELECTOR_UPDATE_REQUEST',
    MULTISITE_SELECTOR_UPDATE_SUCCESS:          'MULTISITE_SELECTOR_UPDATE_SUCCESS',
    MULTISITE_SELECTOR_UPDATE_ERROR:            'MULTISITE_SELECTOR_UPDATE_ERROR',
    MULTISITE_SELECTOR_FILTER_REQUEST:          'MULTISITE_SELECTOR_FILTER_REQUEST',
    MULTISITE_SELECTOR_FILTER_SUCCESS:          'MULTISITE_SELECTOR_FILTER_SUCCESS',
    MULTISITE_SELECTOR_FILTER_ERROR:            'MULTISITE_SELECTOR_FILTER_ERROR',
    MULTISITE_SELECTOR_ORDER_UPDATE:            'MULTISITE_SELECTOR_ORDER_UPDATE',
    MULTISITE_SELECTOR_ITEM_ADD_CUSTOM_OBJ:     'MULTISITE_SELECTOR_ITEM_ADD_CUSTOM_OBJ:',
    MULTISITE_SELECTOR_ITEM_ADD_CINEMA_OBJ:     'MULTISITE_SELECTOR_ITEM_ADD_CINEMA_OBJ',
    MULTISITE_SELECTOR_ITEM_REMOVE:             'MULTISITE_SELECTOR_ITEM_REMOVE',


    //#endregion multisiteSelectorData

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               EVENTS                         //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    EVENTS_ALL_REQUEST:                                'EVENTS_ALL_REQUEST',
    EVENTS_ALL_SUCCESS:                                'EVENTS_ALL_SUCCESS',
    EVENTS_ALL_ERROR:                                  'EVENTS_ALL_ERROR',
    EVENTS_EVENTS_SEND_MAIL_REQUEST:                   'EVENTS_EVENTS_SEND_MAIL_REQUEST',
    EVENTS_EVENTS_SEND_MAIL_SUCCESS:                   'EVENTS_EVENTS_SEND_MAIL_SUCCESS',
    EVENTS_EVENTS_SEND_MAIL_ERROR:                     'EVENTS_EVENTS_SEND_MAIL_ERROR',
    EVENTS_EVENTS_UPDATE_REQUEST:                      'EVENTS_EVENTS_UPDATE_REQUEST',
    EVENTS_EVENTS_UPDATE_SUCCESS:                      'EVENTS_EVENTS_UPDATE_SUCCESS',
    EVENTS_EVENTS_UPDATE_ERROR:                        'EVENTS_EVENTS_UPDATE_ERROR',
    EVENTS_EVENTS_DELETE_REQUEST:                      'EVENTS_EVENTS_DELETE_REQUEST',
    EVENTS_EVENTS_DELETE_SUCCESS:                      'EVENTS_EVENTS_DELETE_SUCCESS',
    EVENTS_EVENTS_DELETE_ERROR:                        'EVENTS_EVENTS_DELETE_ERROR',




    //this is just here so I can always place a comma after the new item when adding a new one
    NONE:                                   'NONE'
};  

